import React, { createContext, useContext, useState } from 'react';
import type { AuthState, AuthContextValue } from '../api/types';

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<AuthState>(() => ({
    token: null,
    userId: null,
    email: null,
    name: null
  }));

  const login = (data: { token: string; id: number; email: string; name: string }) => {
    setState({ token: data.token, userId: data.id, email: data.email, name: data.name });
  };

  const logout = () => setState({ token: null, userId: null, email: null, name: null });

  return <AuthContext.Provider value={{ ...state, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
